export const darkTheme = {
  backgroundColor: 'transparent',
  borderColor: 'white',
  caretColor: 'white',
  color: 'white',
  error: 'white'
}
